export const BREAKFAST_ITEMS = [
    {
        filename: 'bf_nonstarch_cucumber_half',
        name: 'Cucumber',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Cucumbers are a great choice for any meal, but you should aim to fill half your plate with them. Try again.',
        messageRight: 'Great job! Cucumbers are a non-starchy food perfect for filling half your plate.'
    },
    {
        filename: 'bf_nonstarch-tomato_half',
        name: 'Tomatoes',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Tomatoes and foods like fresh salsa are a perfect option for breakfast, but you should aim to fill half your plate with them. Try again.',
        messageRight: 'Perfect! Tomatoes and foods like fresh salsa make for a great non-starchy option to fill half your plate.'
    },
    {
        filename: 'bf_nonstarch-vegmedley_half',
        name: 'Pepper, Onion, Mushroom Medley',
        foodType: 'Non-Starchy',
        correctPortion: 'Half',
        messageWrong: 'Mixing vegetables such as peppers, onions, and mushrooms are great to put on your plate. Just make sure you aim for half your plate. Try again.',
        messageRight: 'Wonderful! A medley of peppers, onions, and mushrooms on half your plate is a great way to meet the non-starchy food recommendation.'
    },
    {
        filename: 'bf_protein-bacon_qt',
        name: 'Bacon',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: `While it's tempting to load up your plate with bacon, you want to keep proteins to only a quarter of your plate. Try again.`,
        messageRight: 'Good choice! You want to be careful not to fill too much of your plate with food like bacon.'
    },
    {
        filename: 'bf_protein-egg_qt',
        name: 'Eggs',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: `Even though eggs aren't high in sodium like typical breakfast meats, you still only want to fill a quarter of your plate with protein. Try again.`,
        messageRight: 'Nice job! Eggs are a great source of protein. Just make sure you try to keep it within a quarter of your plate.'
    },
    {
        filename: 'bf_protein-sausage_qt',
        name: 'Sausage',
        foodType: 'Protein',
        correctPortion: 'Quarter',
        messageWrong: `Even if your sausage choice is made of soy, we still encourage you to only fill a quarter of your plate with protein options. Try again.`,
        messageRight: 'Great! Sausage and even soy sausage can be perfect protein options. Just make sure you limit it to a quarter of your plate.'
    },
    {
        filename: 'bf_starch-toast_quarter',
        name: 'Toast',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Make sure you don't overdo it with starches like bread. Try to keep it to a slice of toast on a quarter of your plate. Try again.`,
        messageRight: 'Perfect! You should also try to aim for whole-grain breads if you choose to have toast with your meal.'
    },
    {
        filename: 'bf_starch-waffle_qt',
        name: 'Waffle',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Foods like waffles and pancakes are breakfast staples. Due to their starch content, you really only want it to fill a quarter of your plate. Try again.`,
        messageRight: 'Good! We know it feels strange not to fill your plate with a whole waffle or pancake, but you want to be especially careful. Be mindful of sugar syrups as well.'
    },
    {
        filename: 'bf_starch-muffin_qt',
        name: 'Muffin',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Muffins can be a tasty addition to breakfast, but you want to be careful. Stick to half a muffin. Try again.`,
        messageRight: 'Great job! Muffins are high in carbohydrates, so you should stick to only half a muffin.'
    },
    {
        filename: 'bf_starch-cereal_qt',
        name: 'Cereal',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Cereal tends to be high in sugar content, so you need to be cautious. Stick to 1/2 cup of sweetened or 3/4 cup of unsweetened cereal. Try again.`,
        messageRight: `Great! Just remember to keep it at only 1/2 cup of sweetened cereal or 3/4 cup of unsweetened cereal.`
    },
    {
        filename: 'bf_starch-bagel_qt',
        name: 'Bagel',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `Bagels are really densely packed with carbohydrates. You should stick to 1/4 of a bagel. Try again.`,
        messageRight: `Nicely done. Bagels are densely packed with carbohydrates, so you want to stick to only 1/4 of a bagel.`
    },
    {
        filename: 'bf_starch-engmuffin_qt',
        name: 'English Muffin',
        foodType: 'Starchy',
        correctPortion: 'Quarter',
        messageWrong: `English muffins are a fine choice, but make sure you're only eating half due to its carbohydrate content. Try again.`,
        messageRight: `Good! Sticking to only half an English muffin is best for controlling carbohydrate intake.`
    },

    // Fruits and Drinks
    {
        filename: 'fruit-juice',
        name: 'Fruit Juice',
        foodType: 'Sugary Drink',
        correctPortion: '',
        messageWrong: 'Fruit juices like orange juice are a great source of Vitamin C, but you should be careful due to its sugar content. Try again without having a cookie or fruit on the side.',
        messageRight: `Good! Fruit juices like orange juice are a great source of Vitamin C, but just make sure you don't have it with a piece of fruit or a sweet like cookies.`
    },
    {
        filename: 'milk',
        name: 'Milk',
        foodType: 'Mild Sugary Drink',
        correctPortion: '',
        messageWrong: `You may be surprised to know that milk has its own sugars. While it is natural, you shouldn't combine it with cookies as tempting as it may be. Try again.`,
        messageRight: `Great! Dietary guidelines suggest having a glass of milk and piece of fruit with your meal is the best combination.`
    },
    {
        filename: 'water',
        name: 'Water',
        foodType: 'Water',
        correctPortion: '',
        messageWrong: `While it's not wrong to have water with your meal, we suggest having milk and a piece of fruit if you can. Stick to water if you're having a sweet dessert like a cookie.`,
        messageRight: `Yes! You can have water with your meal if you plan on having something sweet like a cookie. We recommend milk and a piece of fruit otherwise.`
    },
    {
        filename: 'apple',
        name: 'Apple',
        foodType: 'Fruit',
        correctPortion: '',
        messageWrong: `While fruit may seem like a perfect choice, you definitely don't want to combine it with something like fruit juice.`,
        messageRight: `Great! Having a piece of fruit alongside your meal is a good choice, especially with a glass of milk.`
    },
    {
        filename: 'coffee',
        name: 'Coffee',
        foodType: 'Sugar-Free Drink',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Coffee is fine with breakfast. Just make sure you're careful about adding sugar. Drink black or with some cream.`
    },
    {
        filename: 'banana',
        name: 'Banana',
        foodType: 'Fruit',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Great! Having a piece of fruit alongside your meal is a good choice, especially with a glass of milk.`
    },
    {
        filename: 'yogurt',
        name: 'Yogurt',
        foodType: 'Dairy',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Yogurt is a fine choice, but just make sure it doesn't have extra sugar content. Choose a Greek yogurt or one sweetened with sucralose.`
    },
    {
        filename: 'fruitcup',
        name: 'Fruit Cup',
        foodType: 'Fruit',
        correctPortion: '',
        messageWrong: ``,
        messageRight: `Great! Having a fruit cup alongside your meal is a good choice, especially with a glass of milk.`
    },
]
